import type { Scenario } from "./types";

export function localDateKey(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function hashDateKey(dateKey: string): number {
  let hash = 2166136261;
  for (let index = 0; index < dateKey.length; index += 1) {
    hash ^= dateKey.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function dailyScenarioFor(dateKey: string, scenarios: readonly Scenario[]): Scenario {
  if (scenarios.length === 0) throw new Error("At least one scenario is required");
  return scenarios[hashDateKey(dateKey) % scenarios.length];
}
